import React from "react";
import styles from "./styles.module.css";

interface LogoProps {
  isCollapsed: boolean;
}

export const Logo: React.FC<LogoProps> = ({ isCollapsed }) => {
  return (
    <div className={styles.logo}>
      {isCollapsed ? (
        <img className={styles.logoImage} src="../mainlogo.svg" alt="Logo" />
      ) : (
        <img className={styles.logoImageFull} src="../logoadmin.svg" alt="Full Logo" />
      )}
    </div>
  );
};

